import { Component } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AppSettingService } from '../shared/services/app-setting';
import { MessageBox } from '../shared/message-box/message-box';

@Component({
  selector: 'bottom-sheet',
  templateUrl: './bottom-sheet.component.html',
  styleUrls: ['./bottom-sheet.component.scss'],
  providers: [AppSettingService, MessageBox]
})
export class BottomSheetComponent {

  constructor(public bottomSheetRef: MatBottomSheetRef<BottomSheetComponent>, private appSettingService: AppSettingService, private messageBox: MessageBox) { }

  openLink() {
    this.bottomSheetRef.dismiss();
    this.appSettingService.getAPkByVersion().subscribe(result => {
      if (result.successful) {
        let downloadUrl = `https://services.sayeh.ir/${result.returnValue}.zip`;
        window.open(downloadUrl, "_self");
      } else {
        this.messageBox.showError("", result.response);
      }
    })
  }
}
